/**
 * Ayuda — Administración → Pagos → Órdenes de pago
 * (El menú lateral dice «Recibos»; son comprobantes de pago a proveedores.)
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_PAY_VOUCHERS_ITEM = {
  id: 'vouchersAdmin',
  screenId: 'adm-pay-vouchers',
  label: 'Recibos',
  description: 'Registrá y consultá pagos a proveedores.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá registrás cuando le pagás a un proveedor. Indicás con qué medios salió el dinero (efectivo, transferencia, cheque propio, etc.) y a qué facturas o conceptos se aplica ese pago.',
        paragraphs: [
          'En el menú de la izquierda la opción se llama «Recibos», pero en realidad son órdenes o comprobantes de pago a proveedores.',
        ],
      },
      {
        title: 'Paso 1 — Buscar pagos',
        fields: [
          { label: 'Fecha Desde / Fecha Hasta', description: 'Filtrá por el período del comprobante.' },
          { label: 'Proveedor', description: 'Elegí un proveedor para ver solo sus pagos.' },
          { label: 'Buscar', description: 'Actualiza la lista.' },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Fecha, Proveedor, Tipo de comprobante, Número y Observaciones.',
          'Tocá una fila para ver el detalle.',
          'Ícono de cruz (×) — eliminar el comprobante (pide confirmación).',
        ],
        paragraphs: [
          'El ícono de lápiz no permite editar; al tocarlo también abre el detalle.',
        ],
      },
      {
        title: 'Paso 3 — Cargar un pago nuevo',
        intro: 'El botón + abre «Nuevo Recibo» (comprobante de pago).',
      },
      {
        title: 'Datos del comprobante',
        fields: [
          { label: 'Proveedor', description: 'Buscá y elegí a quién le pagás.' },
          { label: 'Fecha', description: 'Fecha del pago. Obligatoria.' },
          { label: 'Tipo de comprobante', description: 'Orden de pago u otro tipo configurado.' },
          { label: 'Centro / Número', description: 'Punto de venta y numeración del comprobante.' },
        ],
      },
      {
        title: 'Conceptos a pagar',
        intro: 'Indicás a qué se aplica el pago. En cada línea elegís el concepto y el monto:',
        bullets: [
          'Factura de proveedor — imputás el pago a facturas pendientes del proveedor.',
          'Anticipo de pago — pagás por adelantado sin factura específica.',
          'Gastos, sueldos u otros — según lo configurado en el sistema.',
        ],
        paragraphs: [
          'Podés agregar varias líneas con «AGREGAR LINEA».',
          'Elegí primero el proveedor para que aparezcan sus facturas pendientes.',
        ],
      },
      {
        title: 'Forma de pago',
        intro: 'Indicás cómo salió el dinero. En cada línea elegís el medio y el importe:',
        bullets: [
          'Efectivo — dinero de caja.',
          'Banco — transferencia o débito bancario.',
          'Cheques emitidos — cheque propio a nombre del proveedor.',
          'Tarjetas propias — cargo en tarjeta de la empresa. Completá fecha de compra (puede ser distinta a la fecha del recibo), cuotas, primer vencimiento y descripción. Esa descripción se ve después en el detalle del recibo.',
          'Retenciones impositivas — retenciones practicadas al proveedor.',
          'Anticipo — usar un anticipo previo.',
          'Otros medios — según configuración.',
        ],
        paragraphs: [
          'Podés combinar varios medios en un mismo comprobante.',
        ],
      },
      {
        title: 'Observaciones y guardar',
        fields: [
          { label: 'Observaciones', description: 'Notas generales (opcional).' },
          { label: 'Limpiar formulario / Guardar', description: 'Limpiar borra todo. Guardar registra el pago e imputa a las facturas elegidas.' },
        ],
      },
      {
        title: 'Ver el detalle de un pago',
        bullets: [
          'Tipo, número, fecha y datos del proveedor.',
          'Imputaciones — facturas o conceptos pagados.',
          'Forma de pagos — medios e importes. Tocá una fila para ver el detalle del movimiento.',
          'Imprimir — genera el PDF del comprobante.',
          'Observaciones y quién lo creó.',
        ],
      },
      {
        title: 'Eliminar un pago',
        intro:
          'Tocá la cruz en la lista. Confirmá con «Si» o cancelá. Si tiene imputaciones vinculadas, el sistema puede pedir confirmación extra.',
      },
    ],
  },
}
